export enum SalesChannel {
  All = 0,
  Fleet = 1,
  RentalAgency = 2,
  DisabledPerson = 3,
  TaxiDriver = 4,
  RuralProducer = 5,
  Government = 6,
  AutoEscola = 7,
  Others = 8,
  Unknown = 9999
}
